export const getIsFetching = state => state.isFetching
export const getLastUpdated = state => state.lastUpdated
export const getDidInvalidate = state => state.didInvalidate
export const getError = state => state.error
export const getErrorStatus = state => state.errorStatus
export const getPreviousPath = state => state.previousPath
